__webpack_require__.p = "https://static.parastorage.com/services/restaurants-orders-ooi/9647e6c7700011b90983f98644e3558a1fb548eafc758e728419395c/";